import React, { useRef, useState, useEffect } from 'react';

import SatButton from '@components/common/satUI/SatButton';
import SatSignPad from '@components/common/satUI/SatSignPad';
import SatCheckBox from '@components/common/satUI/SatCheckBox';

const EtcInfoSignPopup = props => {
  const {
    searchSignData,
    searchPasteSignData,
    signPasteData,
    onSave,
    signData,
    complete,
    ownerName,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
  } = props;

  const canvasSignNameRef = useRef();
  const canvasSignatureRef = useRef();
  const reportId = 'app_form_05';

  const [pasteCheck, setPasteCheck] = useState(false); // 붙여넣기 체크 여부
  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명
  const [isNameError, setIsNameError] = useState(false);
  const [isSignError, setisSignError] = useState(false);

  useEffect(() => {
    if (
      complete &&
      (!signData.app_form_05_signId_01 || !signData.app_form_05_signId_02) &&
      !isPracticeMode
    ) {
      // 완료된 페이지의 경우 기존 저장된 서명데이터 조회
      searchSignData(
        reportId,
        `${reportId}_signId_02`,
        `${reportId}_signId_01`,
      );
    }
  }, []);

  // 붙여넣기 서명 조회
  const handlePasteCheck = value => {
    if (value) {
      searchPasteSignData();
    }
    setPasteCheck(value);
  };

  const handleButtonClick = () => {
    if (!signNameData) {
      setIsNameError(true);
    }
    if (!signatureData) {
      setisSignError(true);
    }
    if (signNameData && signatureData) {
      onSave(
        signNameData,
        signatureData,
        reportId,
        `${reportId}_signId_02`,
        `${reportId}_signId_01`,
      );
    }
  };

  return (
    <React.Fragment>
      <header className="modal-header">
        <h3 className="layer-tit2">계약사항 자필서명</h3>
      </header>
      <div className="cont modal-scroll-wrap" id="signPadScroll">
        <p className="text-info4">계약자/피보험자의 자필서명을 해주세요.</p>
        <div className="info-box bg-yellow mgt-16">
          <p className="text-info3">
            {`* 보험계약자 또는 피보험자가 미성년자인 경우 법정대리인이 서명하여
            주시기 바랍니다.`}
            <br />
            {`단, 어린이보험을 제외한 모든 피보험자는 직접
            서명하여야 합니다.`}
            <br />
            {`* 보험사기(허위입원, 고의사고, 사고위장, 피해과장
            등)는 형법상 금지된 범죄입니다.`}
          </p>
        </div>
        <SatCheckBox
          value={[pasteCheck]}
          type={'radio'}
          options={[
            { label: '저장했던 성명/서명을 붙여넣으세요.', value: false },
          ]}
          onChange={v => handlePasteCheck(v)}
          customStyleClass="small w-360"
        />
        <div className="sign-pad-wrap">
          <SatSignPad
            canvasRef={canvasSignNameRef}
            name={ownerName}
            title={'계약자 성명 입력'}
            error={isNameError && !signNameData ? '성명을 입력해주세요.' : ''}
            pasteCheck={pasteCheck}
            pasteData={
              !isPracticeMode
                ? signPasteData.app_form_etc_18_sign_01
                : practiceSignName
            }
            signData={complete ? signData.app_form_05_signId_01 : ''}
            onChange={data => setSignNameData(data)}
            onChangePasteCheck={value => setPasteCheck(value)}
          />

          <SatSignPad
            canvasRef={canvasSignatureRef}
            name={'서명'}
            title={'계약자 서명 입력'}
            error={isSignError && !signatureData ? '서명을 입력해주세요.' : ''}
            pasteCheck={pasteCheck}
            pasteData={
              !isPracticeMode
                ? signPasteData.app_form_etc_18_sign_02
                : practiceSignature
            }
            signData={complete ? signData.app_form_05_signId_02 : ''}
            onChange={data => setSignatureData(data)}
            onChangePasteCheck={value => setPasteCheck(value)}
          />
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide ${!signatureData ? 'disabled' : ''}`}
          label={'확인'}
          onClick={() => handleButtonClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default EtcInfoSignPopup;
